import React from 'react'
import YouTubeEmbed from './YouTubeEmbed'
import Image from './Image'
import { FaInfoCircle } from "react-icons/fa";
import { parseStatics } from '../../function/parseStatics';


const ProductIntroduction: React.FC<any> = ({detail}) => {
    const parsedImage = parseStatics(detail.images);

  return (
    <>
        <div className=' w-full my-1 flex justify-center items-center mb-4 xl:mb-0 relative'>
            {/* <h1 className=' text-2xl xl:text-4xl font-bold text-primary-color'>Eczaneye Akademi</h1> */}

            <div className=' absolute -top-7 -right-6'>
                <FaInfoCircle size={32} className=' text-primary-color'/>
            </div>
        </div>

        <div className=' flex flex-col w-full gap-y-7 h-auto  overflow-y-auto relative'>
            {/* HEADER */}
            <div>
                <h2 className=' font-bold text-3xl flex justify-center items-center text-primary-color'>Ürün Tanıtımı</h2>
            </div>

        {/* TEXT  */}
            <div className=' font-light'>
                <p>
                    {
                        detail?.firstText
                    }
                </p>
            </div>
            
            {/* VIDEO */}
            <div className=' w-full '>
                <YouTubeEmbed videoId={detail.videoLink.split('=')[1]}/>
            </div>

            {/* IMAGES */}
            <div className=' flex gap-x-20 justify-center items-center flex-wrap gap-y-5 xl:gap-y-0 w-full'>
                {   
                    parsedImage?.map((image: string, i: number) => (
                        <Image key={i} image={image}/>
                    ))
                }
            </div>

            {/* TEXT */}
            <div  className=' font-light'>
                <p>
                    {
                        detail?.secondText                          
                    }
                </p>
            </div>

        </div>
    </>
  )
}

export default ProductIntroduction